module.exports = __webpack_public_path__ + "static/img/2.1c3ffb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/2.png
// module id = 79O9
// module chunks = 0